import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {filteringInstutionUsers, inputInstutionUsers, InstutionUser} from './instution-user.model';

export const loadInstutionUsers = createAction(
  '[InstutionUser/API] Load InstutionUsers',
  props<{ instutionUsers?: InstutionUser[] }>()
);

export const addInstutionUser = createAction(
  '[InstutionUser/API] Add InstutionUser',
  props<{ instutionUser: InstutionUser }>()
);

export const upsertInstutionUser = createAction(
  '[InstutionUser/API] Upsert InstutionUser',
  props<{ instutionUser: InstutionUser }>()
);

export const addInstutionUsers = createAction(
  '[InstutionUser/API] Add InstutionUsers',
  props<{ instutionUsers: InstutionUser[] }>()
);

export const upsertInstutionUsers = createAction(
  '[InstutionUser/API] Upsert InstutionUsers',
  props<{ instutionUsers: InstutionUser[] }>()
);

export const updateInstutionUser = createAction(
  '[InstutionUser/API] Update InstutionUser',
  props<{ instutionUser: Update<InstutionUser> }>()
);

export const updateInstutionUsers = createAction(
  '[InstutionUser/API] Update InstutionUsers',
  props<{ instutionUsers: Update<InstutionUser>[] }>()
);

export const deleteInstutionUser = createAction(
  '[InstutionUser/API] Delete InstutionUser',
  props<{ id: string }>()
);

export const deleteInstutionUsers = createAction(
  '[InstutionUser/API] Delete InstutionUsers',
  props<{ ids: string[] }>()
);

export const clearInstutionUsers = createAction(
  '[InstutionUser/API] Clear InstutionUsers'
);


//CUSTOM

export const createInstitutionUsers = createAction(
  '[InstutionUser/API] Create Instution Users',
  props<{input?:any}>()
);

export const updateInstitutionUsers = createAction(
  '[InstutionUser/API] Update Instution Users',
  props<{input:inputInstutionUsers}>()
);


export const removeInstitutionUsers = createAction(
  '[InstutionUser/API] Delete Instution Users',
  props<{profileUniqueId:string,id:string}>()
);

export const activateDeactivateUser = createAction(
  '[InstitutionUser/API] ActivateDeactivate Instution User',
  props<{profileUniqueId:string}>()
)

export const getInstitutionUsers = createAction(
  '[InstutionUser/API] get Instution Users',
  props<{filtering?:filteringInstutionUsers}>()
);
